import React from 'react';
import { Text, Icon, Box, Flex } from 'core/components';
import FavoriteButton from 'app/views/core/FavoriteButton';
import ResultMenuItem from './ResultMenuItem';

function Screen({ IconCmp, item, selected, query, onItemClick, ...rest }) {
  const { id, path, name } = item;
  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'screen', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <IconCmp iconSize={22} />
        <FavoriteButton type="page" id={id} name={name} ml={1} />
      </Flex>

      <Box gridArea="title">
        <Text className="title">{name}</Text>
      </Box>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>

      <Text
        className="description"
        gridArea="description"
        muted
        small
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        style={{ overflow: 'hidden' }}
      >
        {path}
      </Text>
    </ResultMenuItem>
  );
}

export default Screen;
